import { EnumConfig } from 'angular-odata';

//#region ODataApi Imports
import { DataFormat } from './dataformat.enum';
//#endregion

export const DataFormatConfig = {
  name: "DataFormat",
  members: DataFormat
} as EnumConfig<DataFormat>;